export default __webpack_public_path__ + "static/media/valorant-agent-sova-full-body.5516dedf.png";